import React from 'react';
import "./_sortBy.scss"
function SortBy({ options, value, onChange }) {
  return (
    <div className="sort-by">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Sort by...</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SortBy;
